// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer'; // Import your root reducer

const store = configureStore({
    reducer: rootReducer, // Set the root reducer
    // You can add middleware and devTools options here if needed
});

export default store;